// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One readable column, like the Request support page. */
.container.privacy-layout {
  max-width: 760px;
  margin: 0 auto 24px;
}

.privacy-card {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-soft);
  padding: 36px 40px;
}

.privacy-card h2 {
  font-size: 1.35rem;
  margin: 32px 0 10px;
}

.privacy-card h2:first-child {
  margin-top: 0;
}

.privacy-card p,
.privacy-card li {
  line-height: 1.65;
}

.privacy-card p {
  margin: 0 0 12px;
}

.privacy-card ul {
  margin: 0 0 12px;
  padding-left: 22px;
  display: grid;
  gap: 8px;
}

/* Underlined: inside running text, color alone doesn't mark a link. */
.privacy-card a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .privacy-card {
    padding: 24px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Privacy.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* One readable column, like the Request support page. */\n.container.privacy-layout {\n  max-width: 760px;\n  margin: 0 auto 24px;\n}\n\n.privacy-card {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-soft);\n  padding: 36px 40px;\n}\n\n.privacy-card h2 {\n  font-size: 1.35rem;\n  margin: 32px 0 10px;\n}\n\n.privacy-card h2:first-child {\n  margin-top: 0;\n}\n\n.privacy-card p,\n.privacy-card li {\n  line-height: 1.65;\n}\n\n.privacy-card p {\n  margin: 0 0 12px;\n}\n\n.privacy-card ul {\n  margin: 0 0 12px;\n  padding-left: 22px;\n  display: grid;\n  gap: 8px;\n}\n\n/* Underlined: inside running text, color alone doesn't mark a link. */\n.privacy-card a {\n  text-decoration: underline;\n}\n\n@media (max-width: 600px) {\n  .privacy-card {\n    padding: 24px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
